// import axios from "axios";
// import Cookies from "js-cookie";
// import baseUrl from "./config";


// // const token = Cookies.get("userToken");
// const token = sessionStorage.getItem('userToken')
// console.log(token,'Token');

// const newRequest = axios.create({
//     baseURL: baseUrl,
//     headers: {
//         Authorization: `Bearer ${token}`,
//     },
// });

// export default newRequest;


import axios from 'axios'
import baseUrl from './config'

const newRequest = axios.create({
  baseURL: baseUrl
})

// Dynamically add token to each request
newRequest.interceptors.request.use(config => {
  const token = sessionStorage.getItem('userToken')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default newRequest
